import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';
import RegistroUsuario from './RegistroEmpleado';
import SkeletonDetalleEmpleado from './SkeletonDetalleEmpleado';

const DetalleEmpleado = () => {
    const { id } = useParams();
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [cargando, setCargando] = useState(true);
    const [empleado, setEmpleado] = useState({});

    /**
     * Se ejecuta la primera vez
     */
    useEffect(() => {
        informacionDetalladaEmpleado();
    }, []);

    //*
    //* obtiene informacion detallada de el empleado al que se le haga click
    //*
    const informacionDetalladaEmpleado = async () => {
        setCargando(true);
        var objDataSend = {};
        objDataSend.idUsuario = id;
        console.log(objDataSend, 'ID DEL PRODUCTO');
        var jDataSend = JSON.stringify(objDataSend);

        const response = await fetch("/api/usuario/DetalleEmpleado/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: jDataSend
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
            console.log('Hubo un problema con la peticion Fetch: ' + error.message);
        });

        if (response.ok) {
            console.log("===================== informacionDetalladaEmpleado =========================");
            console.log(response);
            const data = await response.json();
            console.log("===================== RESPONSETYPE =========================", data);

            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                var empleado = ObjDetalles.table2[0];

                console.log("detalle", empleado)
                setEmpleado(empleado);
                setCargando(false);
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);
    };

    return (
        cargando ?
            <SkeletonDetalleEmpleado />
            :
            <RegistroUsuario empleado={empleado} />
    );
};

export default DetalleEmpleado;